import { combineReducers } from 'redux-immutable'
import authReducer from './auth-reducer'
import authChangePasswordReducer from './auth-change-password-reducer'
import authAuthReducer from './auth-auth-reducer'

export default combineReducers({
  auth: authReducer,
  authChangePassword: authChangePasswordReducer,
  authAuth: authAuthReducer,
})



// WEBPACK FOOTER //
// ./src/reducers/auth/index.js